import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { SessionService } from '../services/active-session-management.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private oauthService: OAuthService,
    private sessionService: SessionService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {


    if (localStorage.getItem('loginUrl')) {
      this.sessionService.setActiveSession();
      if (!localStorage.getItem('isLoginSuccess')) {
        localStorage.setItem('isLoginSuccess', 'true');
        window['dataLayer'] = window['dataLayer'] || [];
        window['dataLayer'].push({
          'event': 'JMLoginSuccessful'
        });
      }
      localStorage.removeItem('loginUrl');
      return true;
    }

    // for Returning user check token exists AND is not expired
    if (this.hasValidOAuthSession()) {
      return true;
    }

    // Non-B2C legacy login path
    if (localStorage.getItem('apiUserModel')) {
      return true;
    }

    // Redirect to register for invalid session 
    return this.router.createUrlTree(['/register']);
  }

  private hasValidOAuthSession(): boolean {
    if (!this.oauthService.getIdentityClaims()) {
      return false;
    }
    const expiration = this.oauthService.getAccessTokenExpiration();
    return expiration ? Date.now() < expiration : false;
  }
}